import RichHtml from "@/components/RichHtml";

export default function Beliefs({ content }) {
  const points = content?.points || [];
  return (
    <section id="beliefs" data-testid="beliefs-section" className="py-24 lg:py-32 bg-[#FAF9F6]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-14">
          <div className="lg:col-span-5 lg:sticky lg:top-24 self-start">
            <div className="text-xs uppercase tracking-[0.2em] text-[#5C6661] mb-4">Who we are</div>
            <h2 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl text-[#1C201E] leading-tight">
              {content?.heading || "What We Believe"}
            </h2>
            <div className="mt-6 text-[#5C6661] leading-relaxed">
              <RichHtml html={content?.intro} testId="beliefs-intro" />
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="divide-y divide-[#E5E0D8]">
              {points.map((p, i) => (
                <div key={i} data-testid={`belief-item-${i}`} className="py-8 first:pt-0">
                  <div className="flex items-baseline gap-4">
                    <span className="font-serif-display text-xl text-[#D4A373] w-8">{String(i + 1).padStart(2, "0")}</span>
                    <div>
                      <h3 className="font-serif-display text-2xl text-[#1C201E]">{p.title}</h3>
                      <div className="mt-3 text-[#5C6661] leading-relaxed">
                        <RichHtml html={p.text} />
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
